import clsx from 'clsx';
import { Heading, type HeadingVariant } from '@hungryroot/ramen';
import styles from './ButtonsGroup.module.css';

interface Props<T> {
  testid?: string;
  handleClick: (option: T) => void;
  options: Array<{ label: string; value: T; className?: string }>;
  selected?: T | null;
  type?: 'basic' | 'card' | 'rounded' | 'large-rounded';
  className?: string;
  buttonClassName?: string;
  labelVariant?: HeadingVariant;
}

export function ButtonsGroup<T>(props: Props<T>) {
  const {
    buttonClassName,
    testid,
    handleClick,
    options,
    type = 'basic',
    selected = null,
    className,
    labelVariant,
  } = props;

  return (
    <div
      data-testid={testid}
      className={clsx(
        {
          [styles.container]: true,
          [styles['basic']]: type === 'basic',
        },
        className
      )}
    >
      {options.map((option, i) => {
        const buttonClass =
          selected === option.value ? styles['button-active'] : styles.button;

        return (
          <button
            key={i}
            data-selected={selected === option.value}
            type="button"
            data-testid={`${testid}-button-${option.label.toLowerCase()}`}
            className={clsx(
              buttonClass,
              {
                [styles['card-button']]: type === 'card',
                [styles['rounded']]: type === 'rounded',
                [styles['large-rounded']]: type === 'large-rounded',
              },
              buttonClassName,
              option?.className
            )}
            onClick={() => handleClick(option.value)}
          >
            {labelVariant ? (
              <Heading variant={labelVariant}>{option.label}</Heading>
            ) : (
              option.label
            )}
          </button>
        );
      })}
    </div>
  );
}
